<template>
  <div class="InsuranceTable">
    <el-table :data="tableData"
              stripe
              style="width: 100%">
      <el-table-column min-width="160px">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="社会保险"
                       header-align="center"
                       align="center">
        <el-table-column label="-"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="el-icon-check"
               v-if="scope.row.Sociology.purchase"></i>
            <i class="el-icon-close"
               v-else></i>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="年金险"
                       header-align="center"
                       align="center">
        <el-table-column label="行内"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="el-icon-check"
               v-if="scope.row.annuity.withinPurchase"></i>
            <i class="el-icon-close"
               v-else></i>
          </template>
        </el-table-column>
        <el-table-column label="行外"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="editShow">
              <i class="el-icon-check"
                 v-if="scope.row.annuity.externalPurchase"></i>
              <i class="el-icon-close"
                 v-else></i>
            </div>
            <div v-else>
              <el-checkbox v-model="scope.row.annuity.externalPurchase"></el-checkbox>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="万能险"
                       header-align="center"
                       align="center">
        <el-table-column label="行内"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="el-icon-check"
               v-if="scope.row.universal.withinPurchase"></i>
            <i class="el-icon-close"
               v-else></i>
          </template>
        </el-table-column>
        <el-table-column label="行外"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="editShow">
              <i class="el-icon-check"
                 v-if="scope.row.universal.externalPurchase"></i>
              <i class="el-icon-close"
                 v-else></i>
            </div>
            <div v-else>
              <el-checkbox v-model="scope.row.universal.externalPurchase"></el-checkbox>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="分红险"
                       header-align="center"
                       align="center">
        <el-table-column label="行内"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="el-icon-check"
               v-if="scope.row.Abonus.withinPurchase"></i>
            <i class="el-icon-close"
               v-else></i>
          </template>
        </el-table-column>
        <el-table-column label="行外"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="editShow">
              <i class="el-icon-check"
                 v-if="scope.row.Abonus.externalPurchase"></i>
              <i class="el-icon-close"
                 v-else></i>
            </div>
            <div v-else>
              <el-checkbox v-model="scope.row.Abonus.externalPurchase"></el-checkbox>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="投资连结险"
                       header-align="center"
                       align="center">
        <el-table-column label="行内"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="el-icon-check"
               v-if="scope.row.Investment.withinPurchase"></i>
            <i class="el-icon-close"
               v-else></i>
          </template>
        </el-table-column>
        <el-table-column label="行外"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="editShow">
              <i class="el-icon-check"
                 v-if="scope.row.Investment.externalPurchase"></i>
              <i class="el-icon-close"
                 v-else></i>
            </div>
            <div v-else>
              <el-checkbox v-model="scope.row.Investment.externalPurchase"></el-checkbox>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="意外险"
                       header-align="center"
                       align="center">
        <el-table-column label="行内"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="el-icon-check"
               v-if="scope.row.Accident.withinPurchase"></i>
            <i class="el-icon-close"
               v-else></i>
          </template>
        </el-table-column>
        <el-table-column label="行外"
                         min-width="160px"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="editShow">
              <i class="el-icon-check"
                 v-if="scope.row.Accident.externalPurchase"></i>
              <i class="el-icon-close"
                 v-else></i>
            </div>
            <div v-else>
              <el-checkbox v-model="scope.row.Accident.externalPurchase"></el-checkbox>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  components: {
  },
  filters: {},
  data() {
    return {
      editShow: true,
      tableData: [
        {
          name: '张三（本人）',
          // 社会保险
          Sociology: {
            // 是否购买
            purchase: true,
          },
          // 年金险
          annuity: {
            // 行内是否购买
            withinPurchase: true,
            // 行内是否购买
            externalPurchase: true,
          },
          // 万能险
          universal: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 分红险
          Abonus: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 投资连结险
          Investment: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 意外险
          Accident: {
            withinPurchase: true,
            externalPurchase: true,
          },
        }, {
          name: '配偶（王五）',
          // 社会保险
          Sociology: {
            // 是否购买
            purchase: true,
          },
          // 年金险
          annuity: {
            // 行内是否购买
            withinPurchase: true,
            // 行内是否购买
            externalPurchase: true,
          },
          // 万能险
          universal: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 分红险
          Abonus: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 投资连结险
          Investment: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 意外险
          Accident: {
            withinPurchase: true,
            externalPurchase: true,
          },
        }, {
          name: '父亲（张一）',
          // 社会保险
          Sociology: {
            // 是否购买
            purchase: true,
          },
          // 年金险
          annuity: {
            // 行内是否购买
            withinPurchase: true,
            // 行内是否购买
            externalPurchase: true,
          },
          // 万能险
          universal: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 分红险
          Abonus: {
            withinPurchase: false,
            externalPurchase: true,
          },
          // 投资连结险
          Investment: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 意外险
          Accident: {
            withinPurchase: false,
            externalPurchase: true,
          },
        }, {
          name: '母亲（李四）',
          // 社会保险
          Sociology: {
            // 是否购买
            purchase: true,
          },
          // 年金险
          annuity: {
            // 行内是否购买
            withinPurchase: false,
            // 行内是否购买
            externalPurchase: true,
          },
          // 万能险
          universal: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 分红险
          Abonus: {
            withinPurchase: true,
            externalPurchase: false,
          },
          // 投资连结险
          Investment: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 意外险
          Accident: {
            withinPurchase: true,
            externalPurchase: false,
          },
        }, {
          name: '子女（张四）',
          // 社会保险
          Sociology: {
            // 是否购买
            purchase: true,
          },
          // 年金险
          annuity: {
            // 行内是否购买
            withinPurchase: true,
            // 行内是否购买
            externalPurchase: true,
          },
          // 万能险
          universal: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 分红险
          Abonus: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 投资连结险
          Investment: {
            withinPurchase: true,
            externalPurchase: true,
          },
          // 意外险
          Accident: {
            withinPurchase: true,
            externalPurchase: true,
          },
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() { },
  methods: {
    edit(bool) {
      this.editShow = bool;
    },
  },
};
</script>
<style lang='scss'>
.InsuranceTable {
  .el-table_2_column_10 {
    background: #ffffff;
  }
}
</style>
